<template>
  <div
    class="Modals d-flex justify-content-center align-items-center"

    :class="{modal}"
  >
    <component v-if="modal"
      :is="modal"
      :key="modal"

      v-bind="toBind"

      @close="close"
    />
  </div>
</template>

<script>

const modals = [
  "EditWebsites", "EditSupplier", "EditBrand", "EditColor", "EditSize", "EditAccount", "EditProductGroup", "ViewOrder", "CustomizeLayout", "EditCategory",
  "AddImageType", "EditTranslation", "EditProductStock", "AddCategoriesTranslations", "EditWebsiteMenu", "OverviewOrderMarkAsBeingShipped",
  "AddOrder", "CustomerInformation", "AddDiscount", "EditDiscount", "Campaign", "EditEditorPackage", "ProductSelector", "EditSynonym", "TableSetting",
  "TemporarilyBlockPostNL", "EditSupplierProductSetting", "CreateSupplierOrder"
]

import { mapState } from "vuex"

export default {
  components: {
    ...modals.reduce((obj, key) => ({
      ...obj,
      [key]: () => import(
        /* webpackChunkName: "modals-chunk" */
        /* webpackMode: "eager" */

      `./Modals/${key}.vue`
        ),
      }), {}),

    ConfirmAction: () => import(
      /* webpackChunkName: "confirm-chunk" */
      /* webpackMode: "eager" */

      `./ConfirmAction.vue`
    ),
    SimpleTextFieldModalTemplate: () => import(
      /* webpackChunkName: "simple-text-modal-template" */
      /* webpackMode: "eager" */

      `./SimpleTextFieldModalTemplate.vue`
    ),
  },
  methods: {
    close() {
      this.$store.commit("pushModal", null)
    },
  },
  computed: {
    ...mapState({
      modal: state => state.modal,
      toBind: state => state.toBind,
    }),
    route() {
      return this.$route
    },
  },
  watch: {
    route() {
      this.close()
    },
  },
}

</script>

<style scoped>

.Modals {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  transition-duration: .2s;
  pointer-events: none;
  background-color: transparent;
}

.modal {
  background-color: rgba(0,0,0,.1);
  pointer-events: all;
}

</style>
